var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible && _vm.commandType,
      expression: "visible && commandType"
    }],
    ref: "contextMenu",
    staticClass: "contextMenu",
    style: {
      'left': `${_vm.posX}px`,
      'top': `${_vm.posY}px`
    },
    attrs: {
      "id": "editorContextMenu"
    },
    on: {
      "contextmenu": _vm.browserContextMenuLock
    }
  }, [!_vm.multiSlctBln ? _c('ul', [_vm.showReName ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.commandType,
      expression: "commandType"
    }],
    on: {
      "click": _vm.changName
    }
  }, [_vm._v("이름변경하기")]) : _vm._e(), _vm.showReName ? _c('li', {
    staticClass: "gap"
  }) : _vm._e(), _vm.treeMode == 'templeteEdit' || _vm.treeMode == 'templete' ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.commandType,
      expression: "commandType"
    }],
    on: {
      "click": _vm.addChild
    }
  }, [_vm._v("하위노드 추가하기")]) : _vm._e(), _vm.treeMode == 'templeteEdit' || _vm.treeMode == 'templete' ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.commandType,
      expression: "commandType"
    }],
    on: {
      "click": _vm.addSibling
    }
  }, [_vm._v("형제노드 추가하기")]) : _vm._e(), _vm.treeMode == 'templeteEdit' || _vm.treeMode == 'templete' ? _c('li', {
    staticClass: "gap"
  }) : _vm._e(), _vm.treeMode == 'templeteEdit' || _vm.treeMode == 'templete' ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.commandType,
      expression: "commandType"
    }],
    on: {
      "click": _vm.selectionDelete
    }
  }, [_vm._v("선택한 노드 삭제")]) : _vm._e(), _vm.treeMode == 'templeteEdit' || _vm.treeMode == 'templete' ? _c('li', {
    staticClass: "gap"
  }) : _vm._e(), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.commandType,
      expression: "commandType"
    }],
    on: {
      "click": _vm.selectionPublicInactive
    }
  }, [_vm._v("선택한 노드 비공개")]), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.commandType,
      expression: "commandType"
    }],
    on: {
      "click": _vm.selectionPublicActive
    }
  }, [_vm._v("선택한 노드 공개")]), _vm.treeMode != 'templeteEdit' ? _c('li', {
    staticClass: "gap"
  }) : _vm._e(), _vm.treeMode != 'templeteEdit' ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.commandType,
      expression: "commandType"
    }],
    on: {
      "click": _vm.memoHandler
    }
  }, [_vm._v(_vm._s(_vm.memoBln ? _vm.memoStr[0] : _vm.memoStr[1]))]) : _vm._e()]) : _vm._e(), _vm.multiSlctBln ? _c('ul', [_vm.treeMode == 'templeteEdit' || _vm.treeMode == 'templete' ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.commandType,
      expression: "commandType"
    }],
    on: {
      "click": _vm.selectionDelete
    }
  }, [_vm._v("선택한 노드 삭제")]) : _vm._e(), _vm.treeMode == 'templeteEdit' ? _c('li', {
    staticClass: "gap"
  }) : _vm._e(), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.commandType,
      expression: "commandType"
    }],
    on: {
      "click": _vm.selectionPublicInactive
    }
  }, [_vm._v("선택한 노드 비공개")]), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.commandType,
      expression: "commandType"
    }],
    on: {
      "click": _vm.selectionPublicActive
    }
  }, [_vm._v("선택한 노드 공개")])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }